import React from 'react';

import { useLocale } from '../providers/locale.provider';
import { LOCALE_LABELS, SUPPORTED_LOCALES, SupportedLocale } from '../i18n/locales';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';

interface Props {
  className?: string;
  size?: 'sm' | 'default';
}

export const LanguageToggle: React.FC<Props> = ({ className, size = 'sm' }) => {
  const { locale, setLocale } = useLocale();

  return (
    <Select value={locale} onValueChange={(v) => setLocale(v as SupportedLocale)}>
      <SelectTrigger size={size} className={className} aria-label="Language">
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {SUPPORTED_LOCALES.map((loc) => (
          <SelectItem key={loc} value={loc}>
            {LOCALE_LABELS[loc]}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
